import { IPublicClientApplication } from "@azure/msal-browser";
import { ITokenSource } from "./ITokenSource";

export class MsalTokenSource implements ITokenSource {
    private readonly instance: IPublicClientApplication;

    constructor(msalInstance: IPublicClientApplication) {
        this.instance = msalInstance;
    }

    private async acquireToken(scopes: string[]): Promise<string> {
        let authResponse = await this.instance.acquireTokenSilent({
            account: this.instance.getAllAccounts()[0],
            scopes: scopes
        });
        return authResponse?.accessToken || '';
    }

    async getUserName(): Promise<string> {
        let active = this.instance.getActiveAccount();
        return active!.username;
    }

    async getToken(scopes: string[]): Promise<string> {
        try {
            return await this.acquireToken(scopes);
        } catch (error) {
            // force login
            await this.instance.loginPopup({
                scopes: scopes
            });

            // try to get a token again
            return await this.acquireToken(scopes);

            // TODO what do we do when the re-login doesn't work?
        }
    }
}